export const catalogItemReducerPath = 'catalogItem';
